import Vue from 'vue'
import VueRouter from 'vue-router'



import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'base',
      component: () => import('../views/Home_v2.vue')
    },
    {
      path: '/apply/:experiment_id',
      name: 'home',
      component: () => import('../views/Home_v2.vue')
    },
    {
      path: '/application',
      name: 'Application',
      component: () => import('../views/Application.vue')
    },
    {
      path: '/slot',
      name: 'Slot',
      component: () => import('../views/Slot.vue')
    },
    {
      path: '/import',
      name: 'Import',
      component: () => import('../views/Import.vue')
    },
    
  ]
})


export default router

